// Dependencies imports
import React from "react";

// Local imports
import InfoIcon from "../../../../Assets/icons/infoicon.png";
import { ReactComponent as SmokingIcon } from "../../../../Assets/icons/smokingcard.svg";
import UnderTraining from "../../../../Assets/icons/undertraining.gif";

// Style imports
import Card from "./cardstyle.module.scss";

const SmokingDetectionCard = () => {
  return (
    <div className={Card.mainbigcontainer}>
      <div className={Card.topinfo}>
        <h4 className={Card.featurename}>Smoking Detection</h4>
        <img className={Card.infoicon} src={InfoIcon} alt="infoicon" />
      </div>
      {/* <div className={Card.middleholder}>
        <div className={Card.leftbigholder}>
          <div className={Card.eventsholder}>
            <h5 className={Card.featuredetails}>In Zone:</h5>
            <div className={Card.datavaluered}>43</div>
          </div>
          <div className={Card.eventsholder}>
            <h5 className={Card.featuredetails}>Outside Zone:</h5>
            <h5 className={Card.datavalueblue}>12</h5>
          </div>
          <br />
          <button className={Card.learnmore}>Learn More</button>
        </div>
        <div className={Card.rightholder}>
          <div className={Card.iconholderred}>
            <SmokingIcon className={Card.icon} />
          </div>
        </div>
      </div> */}
      <div className={Card.underprogressholder}>
        <img
          src={UnderTraining}
          className={Card.undertraininggif}
          alt="undertraininggif"
        />
        <h4 className={Card.underprogress}>Training under progress</h4>
      </div>
    </div>
  );
};

export default SmokingDetectionCard;
